/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import {PIG_PATH} from '@app/components/icons/PigPath';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

export const FluxerIcon = observer((props: React.SVGProps<SVGSVGElement>) => {
	const {t} = useLingui();

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 381 381"
			role="img"
			aria-label={t`hryuxer application icon`}
			{...props}
		>
			<rect fill="var(--brand-primary)" height={381} rx={190.5} width={381} />
			<path
				fill="var(--brand-primary-fill)"
				fillRule="evenodd"
				clipRule="evenodd"
				d={PIG_PATH}
			/>
		</svg>
	);
});
